const routes = {
  index: {
    path: 'index.consult.dispatch',
    url: '/depeche',
  },
  home: {
    path: 'index.consult.dispatch.home',
    url: '/accueil',
  },
  new: {
    path: 'index.consult.dispatch.new',
    url: '/creer',
  },
  edit: {
    path: 'index.consult.dispatch.edit',
    url: '/modifier',
  },
  details: {
    path: 'index.consult.dispatch.details',
    url: '/details',
  },
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/dispatch/routes.js